import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Caption from "../Caption";
import styles from "./Image.css";

class Image extends Component {
  render() {
    const { data } = this.props.block;
    const aspectRatio = data.orig_width && data.orig_height;
    let paddingBottom;
    if (aspectRatio) {
      paddingBottom = `${(1 / (data.orig_width / data.orig_height)) * 100}%`;
    }

    return (
      <div className={styles.root}>
        {aspectRatio ? (
          <div className={styles.lazyContainer} style={{ paddingBottom }}>
            <img
              id={data.image_id}
              data-src={data.src}
              alt={data.alt_text}
              className={classNames(styles.image, "lazyload")}
            />
          </div>
        ) : (
          <div className={styles.container}>
            <img
              id={data.image_id}
              src={data.src}
              alt={data.alt_text}
              className={styles.image}
            />
          </div>
        )}
        <Caption>{this.props.children}</Caption>
      </div>
    );
  }
}

Image.propTypes = {
  block: PropTypes.object.isRequired,
};

export default Image;
